requestAnimationFrame(() => {
  scriptController.executeWhenScriptLoaded('cart.js', () => {
    themeBase.onDOMContentLoadedTrigger(() => {
      if (customElements.get('cart-rewards-bar')) return;

      customElements.define(
        'cart-rewards-bar',
        class CartRewardsBar extends HTMLElement {

          constructor() {
            super();

            const cfg = window.cartRewardsConfig || {};
            this.step2Threshold = cfg.step2Threshold || 50000;
            this.step3Threshold = cfg.step3Threshold || 100000;
            this.strings        = cfg.strings || {};

            this.msgText = this.querySelector('.cart-rewards-bar__msg-text');
            this.fill    = this.querySelector('.cart-rewards-bar__fill');
            this.stepEls = this.querySelectorAll('.cart-rewards-bar__step');
          }

          connectedCallback() {
            this._cartUpdateUnsub     = subscribe(PUB_SUB_EVENTS.cartUpdate,    this._onUpdate.bind(this));
            this._quantityUpdateUnsub = subscribe(PUB_SUB_EVENTS.quantityUpdate, this._onUpdate.bind(this));

            if (cartBase.wasUpdate) this._onUpdate(this);
          }

          disconnectedCallback() {
            this._cartUpdateUnsub?.();
            this._quantityUpdateUnsub?.();
          }

          _onUpdate(event) {
            const total = event?.cartData?.total_price ?? cartBase?.cartData?.total_price;
            if (total !== undefined) {
              this._updateUI(total);
            } else {
              cartBase.getData().then(d => this._updateUI(d.total_price));
            }
          }

          _updateUI(total) {
            const step2Done = total >= this.step2Threshold;
            const step3Done = total >= this.step3Threshold;

            // Fill (grows right → left)
            const pct = Math.min((total / this.step3Threshold) * 100, 100);
            if (this.fill) this.fill.style.width = `${pct}%`;

            // Step dots
            this.stepEls.forEach(el => {
              const n    = parseInt(el.className.match(/step--(\d)/)?.[1]);
              const done = n === 1 || (n === 2 && step2Done) || (n === 3 && step3Done);
              el.classList.toggle('cart-rewards-bar__step--done', done);

              if (done && !el.dataset.animated) {
                el.dataset.animated = '1';
                el.classList.add('cart-rewards-bar__step--pop');
                setTimeout(() => el.classList.remove('cart-rewards-bar__step--pop'), 600);
              }
              if (!done) delete el.dataset.animated;
            });

            this.classList.toggle('cart-rewards-bar--all-done', step3Done);

            // Message
            if (!this.msgText) return;
            if (step3Done) {
              this.msgText.innerHTML = this.strings.msgComplete || '🎉 פתחת את כל ההטבות!';
            } else if (step2Done) {
              const left = Shopify.formatMoney(this.step3Threshold - total);
              this.msgText.innerHTML = (this.strings.msgToStep3 || 'הוסף עוד <b>{{amount}}</b>').replace('{{amount}}', left);
            } else {
              const left = Shopify.formatMoney(this.step2Threshold - total);
              this.msgText.innerHTML = (this.strings.msgToStep2 || 'הוסף עוד <b>{{amount}}</b>').replace('{{amount}}', left);
            }
          }
        }
      );
    });
  });
});
